import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import RoundLoader from "../../../Components/Common/RoundRingLoader";
import { useDebounce } from "../../../Components/useDebounce";
import { AESEncryption, ApiResDecrypt, formatDate, noDataFound, splitDateSlash } from "../../../CommonMethhods/CommonMethods";
import { partner_Api } from "../../../Configuration/Partner_URL";
import { Tab } from "react-bootstrap";
import Loader from "../../../Components/Common/Loader";
import LoaderForSearch from "../../../Components/Common/LoaderForSearch";
import SmallLoader from "../../../Components/Common/smallLoader";
import { axiosPartnerJsonReserv1 } from "../../../CommonMethhods/axiosPartnerInterceptor";

function PayoutMasterTable(props) {
  const storeToken = localStorage.getItem("ssoToken");
  const [loader, setLoader] = useState(false);
  const [count, setCount] = useState("");
  const [tableData, setTableData] = useState([]);
  const [serverErr, setServerErr] = useState("");
  const [offset, setOffset] = useState(1);
  const [scrollLoader, setScrollLoader] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const addData = props?.addData;
  const setAddData = props?.setAddData;
  const forUpdateMaster = props?.forUpdateMaster;

  const [downloadBtnLoader, setDownloadBtnLoader] = useState(false);
  const debouncedValue = useDebounce(searchInput, 1000);

  useEffect(() => {
    handleSearchApMaster(debouncedValue);
  }, [debouncedValue]);

  const getApMasterList = async (viewType = "grid", limit = 10, offset = 1, value = ""
  ) => {
    if (viewType === "grid" && offset === 1) {
      setLoader(true);
    }
    let payloadValue = {
      filetype: viewType,
      offset: offset,
      limit: limit,
      search: value,
    };
    console.log(payloadValue, "payloadValue");

    let encPayload = AESEncryption(payloadValue);

    try {
      const getApList = await axiosPartnerJsonReserv1.post(
        partner_Api.Get_PartnerTableDetails,
        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getApList?.data);
      console.log(res, "tableResponse");

      if (res?.status === 0) {
        
        setCount(res?.data?.totalCnt);
        if (viewType === "grid") {
          if (offset > 1) {
            setTableData((prev) => {
              return [...prev, ...res?.data?.partners];
            });

          } else {
            setTableData(res?.data?.partners);
          }

        } else if (viewType === "excel") {
          if (res?.data) {
            window.open(res?.data, "_self", "noopener,noreferrer");
            toast.success("File Downloaded successfully");
          }
        }
        setAddData(false)
      }
      else {
        if (viewType === "grid") {
          setTableData([]);
          setServerErr(res?.message);
        } else {
          toast.error(res?.message);
        }
      }
    } catch (error) {
      console.log(error);
      if (viewType === "grid") {
        setServerErr(error?.message);
      } else {
        toast.error(error?.message);
      }
    } finally {
      setDownloadBtnLoader(false);
      setScrollLoader(false);
      setLoader(false);
    }
  };

  const handleScrollApMaster = () => {
    const a = document.querySelector("#apMasterpageId");
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight) {
      if (count <= offset * 10) {
        // setApScroll(false);
        setScrollLoader(false);
        return;
      }
      setOffset((prev) => prev + 1);
      setScrollLoader(true);
    }
  };

  useEffect(() => {
    getApMasterList("grid", 10, offset, searchInput)
  }, [addData, offset])

  const handleType = () => {
    setDownloadBtnLoader(true);
    getApMasterList("excel", -1, -1, searchInput);
  };

  const handleSearchApMaster = (data) => {
      setTableData([]);
      setOffset(1);
      getApMasterList("grid", 10, offset, data);
  }

  const UpdateItem=(item)=>{
    forUpdateMaster(item)
  }

  const partnerModuleTable = (tableData) => {
    return (
      tableData &&
      tableData.map((item, key) => {

        return (
          <tr key={key}>
            <td>{item?.apCName || "-"}</td>
            <td>{item?.apCode || "-"}</td>
            <td>{item?.partnerCode || "-"}</td>
            <td>{item?.partnerModule || "-"}</td>
            <td>{item?.partnerSharing || 0}%</td>
            <td>{item?.apModule || "-"}</td>
            <td>{item?.apSharing || 0}%</td>
            <td>{item?.apType || "-"}</td>
            <td>{item?.pan || "-"}</td>
            <td>{item?.bankAcNo || "-"}</td>
            <td>{item?.ifsc || "-"}</td>
            <td>{item?.bankName || "-"}</td>
            <td>{item?.apRegistered || "-"}</td>
            <td>{item?.gstRegistered || "-"}</td>
            <td>{item?.gstNo || "-"}</td>
            <td>{item?.segment || "-"}</td>
            <td>{item?.exch || "-"}</td>
            <td>{item?.sapCode || "-"}</td>
            <td>{item?.nseRegistration || "-"}</td>
            <td>{item?.bseRegistration || "-"}</td>
            <td>{item?.createdBy || "-"}</td>
            <td>{splitDateSlash(formatDate(item?.createdOn)) || "-"}</td>
            <td>
              <button
                type="button"
                className="icon-Edit edit-icon"
              onClick={() => UpdateItem(item)}

              ></button>
            </td>
          </tr>
        );
      })
    );
  };
  console.log(tableData, "tableData");


  return (
    <div className="master-table-wrapper">
      <div className="tableHead">
        
        <div className="wrap-search">
          <div className="form-group">
            <input
              type="text"
              name="search-text"
              id="SearchInput"
              className="input-st mt-3"
              value={searchInput}
              placeholder="Search here..."
              autoComplete="off"
              onChange={(e) => {
                const { selectionStart, selectionEnd, value } = e.target;

                  let input = value
                  .toUpperCase()
                  .replace(/[^A-Z0-9]/g, "")
                  e.target.value = input;
                  e.target.setSelectionRange(selectionStart, selectionEnd);                     
                setSearchInput(input);
              }}
              onPaste={(e) => {
                e.preventDefault();
                const pasteText = e.clipboardData.getData("text").toUpperCase().trim();
                const filtered = pasteText.replace(/[^A-Z0-9]/g, "");
                setSearchInput(filtered);
            }}
            />
          </div>
          <button type="button" className="downloadBtn" onClick={handleType}>
            {downloadBtnLoader ? (
              <div className="download-loader">
                <SmallLoader />
              </div>
            ) : (
              "Download"
            )}
          </button>
        </div>
      </div>
      <h4 className="master-title mb-3">Master Table</h4>

      <Tab.Pane eventKey="ApMaster">
        {loader ? (
          <div className="loader-div for-grid-section">
            <Loader />
          </div>
        ) : (
          <div className="scroll-table master_table" id="for-scroll-left">
            {tableData && tableData?.length > 0 ? (
              <table className="table">
                <thead>
                  <tr className="masterTableHead">
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col" colSpan="5" className="">
                      Base Brokerage Detail
                    </th>
                    <th scope="col"></th>
                    <th scope="col" className=""></th>


                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                  </tr>
                  <tr>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col" colSpan="3">
                      Option
                    </th>


                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th></th>
                  </tr>
                  <tr>
                    <th scope="col">AP Name</th>
                    <th scope="col">AP Code</th>
                    <th scope="col">Partner Code</th>
                    <th scope="col">Partner Module</th>
                    <th scope="col" className="">
                      Partner Sharing
                    </th>
                    <th scope="col">Module</th>
                    <th scope="col">AP Sharing</th>
                    <th scope="col">AP Type</th>
                    <th scope="col">PAN</th>
                    <th scope="col" className="">
                      Account Number
                    </th>
                    <th scope="col">Ifsc Code</th>
                    <th scope="col">Bank Name</th>
                    <th scope="col">Is AP Registered</th>
                    <th scope="col">Is GST Registered</th>
                    <th scope="col">GST Number</th>
                    <th scope="col">Segment</th>
                    <th scope="col">Exchange</th>
                    <th scope="col">SAP Code</th>
                    <th scope="col">NSE Registration Number</th>
                    <th scope="col">BSE Registration Number</th>
                    <th scope="col">Created By</th>
                    <th scope="col">Created On</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>

                <tbody onScroll={handleScrollApMaster} id="apMasterpageId">
                  {partnerModuleTable(tableData)}
                  {scrollLoader && (
                    <div className="loader-center">
                      <LoaderForSearch />
                    </div>
                  )}
                </tbody>
              </table>
            )
              :
              <div className="for-grid-section">
                {serverErr && noDataFound(serverErr)}
              </div>
            }
          </div>
        )
        }
      </Tab.Pane>

    </div>
  );
}

export default PayoutMasterTable;
